var CustomTableLinkField = function (config) {
  jsGrid.Field.call(this, config);
};

CustomTableLinkField.prototype = new jsGrid.Field({
  css: "table-link", // redefine general property 'css'

  itemTemplate: function (value, item) {
    var valueType = value.type;
    var $link = $("<a>").attr("href", value.url).text(value.content);

    var $grid = this._grid._container;

    if (valueType) {
      $link.attr("data-action-type", valueType);

      switch (valueType) {
        case "delete-row":
          $link.on("click", removeRowFromGrid.bind(this, item, $grid));
          break;
      }
    }

    return $link;

    // Function definitions used above...
    function removeRowFromGrid(row, $grid) {
      $grid.jsGrid("deleteItem", row);
    }
  },

  sorter: function (a, b) {
    var isDefined = function (val) {
      return typeof val !== "undefined" && val !== null;
    };

    var str1 = a.content,
      str2 = b.content;

    if (!isDefined(str1) && !isDefined(str2)) return 0;

    if (!isDefined(str1)) return -1;

    if (!isDefined(str2)) return 1;

    return ("" + str1).localeCompare("" + str2);
  },

  // @todo Perhaps delete this later if found to be not necessary, as was causing errors during development
  // insertTemplate: function(value) {
  //     return this._insertPicker = new $('<a>').attr('href', value).text(value);
  // },

  editTemplate: function (value) {
    return (this._editPicker = new $("<a>")
      .attr("href", value.url)
      .text(value.content));
  },

  insertValue: function () {
    return this._insertPicker;
  },

  editValue: function () {
    return this._editPicker;
  },
});

module.exports = CustomTableLinkField;
